// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__-lwrP","content":"default_content__sDk7f","button":"default_button__J9GUa"};